<template>
  <div v-if="isVisible" class="c-loading">
    <div class="c-loading-image"><img src="/loading.gif" /></div>
  </div>
  <div v-else class="row">
    <div v-show="searchs.length == 0" class="c-loading">
      <div class="c-loading-image"><img src="/loading.gif" /></div>
    </div>
    <div
      class="col-md-3 mb-4 p-2"
      v-for="search in searchs.data"
      :key="search.id"
    >
      <activity :activity="search" test="test" :lang="lang"></activity>
    </div>
    <div
      class="col-12 mb-4 p-2"
      v-if="searchs.data != null && searchs.data.length == 0"
    >
      <div class="c-searc-empty">
        <img src="/images/no-result.png" />
        <div class="c-searc-empty-title">{{ trans('No results') }}</div>
        <div class="c-searc-empty-subtitle">
          {{ trans('Try searching for something else') }}
        </div>
      </div>
    </div>
    <infinite-loading
      v-if="!isFinished"
      @distance="1"
      @infinite="infiniteHandler"
    ></infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
export default {
  props: ['lang'],
  data() {
    return {
      searchs: [],
      isVisible: false,
      page: 2,
      isFinished: false,
    };
  },
  methods: {
    loadSearchs() {
      // Fire.$emit('searching');
      //   axios.get('/api/search').then(({ data }) => (this.searchs = data))
    },
    infiniteHandler($state) {
      if (!this.isFinished) {
        //this.isVisible = true;
        let query = this.$parent.$root.search;
        let date = '';
        let age = this.$parent.$root.searchAge;
        let time = this.$parent.$root.searchTime;
        let category = this.$parent.$root.searchCategory;
        let city = this.$parent.$root.searchCity;
        let district = this.$parent.$root.searchDistrict;
        let sortby = this.$parent.$root.sortby;

        if (this.$parent.$root.searchDate == 'today') {
          date = 'today';
        } else if (this.$parent.$root.searchDate == 'tomorrow') {
          date = 'tomorrow';
        } else if (this.$parent.$root.searchDate == 'weekend') {
          date = 'weekend';
        } else if (
          this.$parent.$root.searchDate != '' &&
          this.$parent.$root.searchDate != null
        ) {
          date = this.$parent.$root.searchDate;
        }

        axios
          .get(
            `/api/updateSearch?
            page=${this.page}
            &date=${date}
            &q=${query}
            &age=${age}
            &time=${time}
            &category=${category}
            &city=${city}
            &district=${district}
            &sortby=${sortby}`,
          )
          .then(data => {
            //this.isVisible = false;
            data.data.data.length == 0 ? (this.isFinished = true) : null;

            data.data.data.forEach((value, index) => {
              this.searchs.data.push(value);
            });
            $state.loaded();
          })
          .catch(() => {});

        this.page = this.page + 1;
      } else {
      }
    },
    onSearching() {
      Fire.$on('searching', () => {
        this.isVisible = true;
        let query = this.$parent.$root.search;
        let date = '';
        let age = this.$parent.$root.searchAge;
        let time = this.$parent.$root.searchTime;
        let category = this.$parent.$root.searchCategory;
        let city = this.$parent.$root.searchCity;
        let district = this.$parent.$root.searchDistrict;
        let sortby = this.$parent.$root.sortby;

        if (this.$parent.$root.searchDate == 'today') {
          date = 'today';
        } else if (this.$parent.$root.searchDate == 'tomorrow') {
          date = 'tomorrow';
        } else if (this.$parent.$root.searchDate == 'weekend') {
          date = 'weekend';
        } else if (
          this.$parent.$root.searchDate != '' &&
          this.$parent.$root.searchDate != null
        ) {
          date = this.$parent.$root.searchDate;
        }

        axios
          .get(
            `/api/updateSearch?
            date=${date}
            &q=${query}
            &age=${age}
            &time=${time}
            &category=${category}
            &city=${city}
            &district=${district}
            &sortby=${sortby}`,
          )

          .then(data => {
            this.isVisible = false;
            this.searchs = data.data;
          })
          .catch(() => {});

        this.page = 2;
        this.isFinished = false;
      });

      this.loadSearchs();
    },
  },
  created() {
    this.onSearching();
  },
  components: {
    'infinite-loading': InfiniteLoading,
  },
};
</script>
